import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { syncUrlParams, search } from '../../state/actions';
import { StateType } from '../../../state/state.types';
import { SEARCH_TYPES_WITH_FILTERS } from '../../searchContansts';

const mapState = ({
  results,
  user,
  searchMenu,
  queryParams,
  search: searchData,
}: StateType) => ({
  searchLoading: results.searchLoading,
  query: results.query,
  trialExpired: user.trialExpired,
  quotaExceeded: user.quotaExceeded,
  isOpen: searchMenu.isOpen,
  hasSubHeader: SEARCH_TYPES_WITH_FILTERS.includes(queryParams.type),
  enableWatchers: searchData.enableWatchers,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  replaySearch(url: string, reason: string) {
    dispatch(syncUrlParams(url));
    dispatch(search({ reason, updateURL: false }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
